import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
// import { MdePopoverModule } from '@material-extended/mde';

import { SharedRoutingModule } from './shared-routing.module';
import { ConfigurationService } from './services/configuration.service';
import { MaterialModule } from '../core/material.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { ImageService } from './services/image.service';
import { FilterByNamePipe } from './pipes/filter-by-name.pipe';
import { FilterByServiceNamePipe } from './pipes/filter-by-service-name.pipe';
import { FilterByProductNamePipe } from './pipes/filter-by-product-name.pipe';
import { FilterByTaskGroupPipe } from './pipes/filter-by-taskGroup';
import { FilterByStatusPipe } from './pipes/filter-by-status.pipe';
import { InduMapComponent } from './components/indu-map/indu-map.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { AddressComponent } from './components/address/address.component';
import { IndCalendarComponent } from './components/calendar/ind-calendar/ind-calendar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import localeEsAR from '@angular/common/locales/es-AR';
import localeEsARExtra from '@angular/common/locales/extra/es-AR';
import { UserService } from './services/user.service';
import { EnumToArrayPipe } from './pipes/enum-to-array.pipe';
import { ToastComponent } from './components/toast/toast.component';
import { ItemTemplateComponent } from './components/calendar/item-template/item-template.component';
import { SharedServices } from './services/shared.service';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { StarRatingComponent } from './star-rating/star-rating.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { StateSwitcherComponent } from './components/state-switcher/state-switcher.component';
import { BrowserModule } from '@angular/platform-browser';
import { FilterBySupplierPaymentPipe } from './pipes/filter-by-supplier-payment.pipe';
import { MatChipsModule } from '@angular/material/chips';
import { MultiselectAutocompleteComponent } from './components/multiselect-autocomplete/multiselect-autocomplete.component';
import { InTransitComponent } from './components/in-transit/in-transit.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { RangeDatesComponent } from './components/range-dates/range-dates.component';
import { HideIfNoPermissionDirective } from '../directives/HideIfNoPermissionDirective';

registerLocaleData(localeEsAR, 'es', localeEsARExtra);

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        SharedRoutingModule,
        MaterialModule,
        MatCheckboxModule,
        MatBadgeModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        FormsModule,
        ReactiveFormsModule,
        GoogleMapsModule,
        MatAutocompleteModule,
        MatCardModule,
        NgbCarouselModule,
        AddressComponent,
        InduMapComponent,
        ColorPickerModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        MatMenuModule,
        MatChipsModule,
        FilterByNamePipe,
        FilterByServiceNamePipe,
        FilterBySupplierPaymentPipe,
        FilterByProductNamePipe,
        FilterByTaskGroupPipe,
        FilterByStatusPipe,
        EnumToArrayPipe,
        IndCalendarComponent,
        ToastComponent,
        ItemTemplateComponent,
        FileUploaderComponent,
        StarRatingComponent,
        StateSwitcherComponent,
        MultiselectAutocompleteComponent,
        InTransitComponent,
        RangeDatesComponent,
        HideIfNoPermissionDirective
    ],
    exports: [
        MaterialModule,
        NgbCarouselModule,
        FilterByNamePipe,
        FilterByServiceNamePipe,
        FilterBySupplierPaymentPipe,
        FilterByProductNamePipe,
        FilterByTaskGroupPipe,
        FilterByStatusPipe,
        EnumToArrayPipe,
        FormsModule,
        MatCheckboxModule,
        MatBadgeModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        InduMapComponent,
        AddressComponent,
        FileUploaderComponent,
        RangeDatesComponent,
        IndCalendarComponent,
        MatAutocompleteModule,
        MatCardModule,
        MatProgressSpinnerModule,
        StarRatingComponent,
        MatMenuModule,
        MatChipsModule,
        StateSwitcherComponent,
        InTransitComponent,
        ColorPickerModule,
        MultiselectAutocompleteComponent,
        HideIfNoPermissionDirective
    ],
    providers: [
        ConfigurationService,
        UserService,
        DatePipe,
        SharedServices,
        ImageService,
        {
            provide: LOCALE_ID,
            useValue: 'es-AR'
        },
    ]
})
export class SharedModule { }
